var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"color-picker"},[(_vm.preview)?_c('div',{staticClass:"color-picker__preview",style:({ 'backgroundColor': _vm.value })}):_vm._e(),_vm._v(" "),_c('div',{attrs:{"id":"color-picker","value":_vm.value},on:{"input":function($event){_vm.updateValue($event.target.value)}}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-64d462f2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Code/properties/ColorPicker.vue
// module id = null
// module chunks = 